import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-report-model',
  templateUrl: './confirm-report-model.component.html',
  styleUrls: ['./confirm-report-model.component.scss']
})
export class ConfirmReportModelComponent implements OnInit {
  @ViewChild('allSelected') private allSelectedOption: MatOption;
  report = new FormControl();
  reportModel = [
    { value: 'SFR_MODEL', label: 'Single Family' },
    { value: 'MULTI_FAMILY_MODEL', label: 'Multi Family' },
    { value: 'CONDO_MODEL', label: 'Condo' },
  ];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ConfirmReportModelComponent>
  ) {}

  ngOnInit(): void {
    this.report.setValue([0, ...this.reportModel.map(item => item.value)]);
  }

  get isButtonDisabled(): boolean {
    const values = this.report?.value || [];
    const count = values.filter(v => v !== 0).length;
    return count === 0;
  }

  get selectedReportLabel(): string {
    const values = this.report.value;
    if (!values || values.length === 0) return '';
    if (values.includes(0)) return 'All';
    return values
      .map(v => this.reportModel.find(r => r.value === v)?.label)
      .filter(Boolean)
      .join(', ');
  }

  toggleOne(all) { 
    if (this.allSelectedOption.selected) {  
        this.allSelectedOption.deselect();
        return false;
    }
    if(this.report.value.length==this.reportModel.length)
      this.allSelectedOption.select();
 }

  proceed() {
    this.data.proceedAction(this.report.value.filter(x=> x != 0), () => {});
  }

  proceedCancel() {
    this.dialogRef.close();
  }

  toggleAllSelection() {
    if (this.allSelectedOption.selected) {
      this.report.setValue([0, ...this.reportModel.map(item => item.value)]);
    } else {
      this.report.setValue([]);
    }
  }

}
